import { CreateUrl, CallGetAPI, CallPostAPI, CallPutAPI, CallDeleteAPI } from 'Utils/ApiHelper.js';
import CHF from "assets/CHF.png";
import CHF1P from "assets/CHF1P.png";
import CHF2P from "assets/CHF2P.png";
import ZL from "assets/ZoneLog_Logger.png"
import { GutermannModelConverter } from "../../Utils/GutermannModelCoverter";
import yellowMarker from '../../assets/mapLocationMarkers/pinYellow.png';
import redMarker from '../../assets/mapLocationMarkers/pinRed.png';
import { APILoggerDetail, buildAPILoggerDetail } from 'models/APILoggerDetail';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import { IntlShape } from 'react-intl';
import { APISiteLoggerDetail } from './LoadSiteDetailsData';


export interface Boundary {
    site: number
    path: Array<Coordinates>
    styling: BoundaryStyling
}
export interface BoundaryStyling {
    strokeWeight: number
    strokeColor: string
    areaColor: string
    transparency: number
}

export interface Coordinates {
    lat: number | null
    lng: number | null
}

export interface Company {
    name: string
    id: number
    isParent: boolean
}

export interface GPS {
    position: { lat: number, lng: number }
    icon: string
    serial: number
    id: number
    tooltip: string
    siteId: number


}




export interface Name {
    siteNameTemp: string
    siteRefTemp: string
}

export interface Site {
    siteId: number;
    siteNameUserFriendly: string;
    siteName: string;
    created: Date;
    deleted: Date | null;
    latitude: number | null;
    longitude: number | null;
    //devices: Array<Device>;
    groups: Array<{ id: number; displayName: string }>;
    defaultSite: boolean;
    fkCompanyId: number;
    fkEASiteId: number | null;
    EASite: string;
    lastUpdate: Date | null;
    alarmState: number | null;
    alarmsEnabled: number | null;
    loggers: Array<APILoggerDetail>;
    LastReading?: Date | null;
    HasActiveLoggers?: string;
    boundary?: string
    isParent?: boolean
    companyName: string | null

}

export const defaultCenter = window.location.hostname.includes("zonelog.net")
    ? { lat: 47.17442830752493, lng: 8.517189402835617 }
    : { lat: 50.744094943532446, lng: -3.99597602646894 };


const createSuccessNotification = (intl: IntlShape): void => {
    NotificationManager.success(intl.formatMessage({ id: 'Saved Changes' }), intl.formatMessage({ id: 'Success' }))

};

const createErrorNotification = (intl: IntlShape): void => {
    NotificationManager.error(intl.formatMessage({ id: 'Error Saving Changes' }), "", 5000, () => {
        alert(window.location.hostname.includes('zonelog.net') ? intl.formatMessage({ id: 'contact ZONELOG Support' }) : intl.formatMessage({ id: 'contact Ashridge Support' }));
    });
};


export const reloadData = (
    setLoading: (value: boolean) => void,
    setBoundaries: (boundaryData: Boundary[]) => void,
    companies: Company[],
    setCompanies: (companiesData: Company[]) => void,
    setMarkers: (markersData: GPS[]) => void,
    setActiveSites: (activeSites: Site[]) => void,
    setInactiveSites: (inactiveSites: Site[]) => void,
    setLoggersToBeAssigned: (loggers: APILoggerDetail[]) => void,
    setAuthorized: (isAuth: boolean) => void


): void => {
    setLoading(true)
    setBoundaries([])
    CallGetAPI(CreateUrl('/api/aquaguard/SitesForCompany?companyId=' + sessionStorage.getItem('companyId') + '&filterGroup=' + sessionStorage.getItem('filterGroupId')), {})
        .then(data => {
            CallGetAPI(CreateUrl(`/api/aquaguard/GetCompanyAndChildren?companyGUID=${sessionStorage.getItem('companyGuid')}`), {})
                .then(companyData => {
                    const companiesTemp = [...companies]
                    companyData.forEach(company => companiesTemp.push({ name: company.name, id: company.id, isParent: company.parentId ? false : true }))
                    companiesTemp.sort(function (x, y) {
                        return Number(y.isParent) - Number(x.isParent)
                    })
                    if (data.length > 0) {
                        const preppedData:Site[] = data.map((site:Site) => {
                            if (site.siteName) {
                                site.siteName = `${site.siteName.charAt(0).toUpperCase()}${site.siteName.slice(1)}`
                                return site
                            } else return site
                        })

                        preppedData.sort((a, b) => {
                            return a.siteName < b.siteName ? -1 : 1
                        })
                        const activeSiteData = []
                        const inActiveSiteData = []
                        const unAssignedLoggers: APISiteLoggerDetail[] = []
                        const markersTemp: GPS[] = []
                        const boundariesTemp: Boundary[] = []
                        preppedData.forEach((site: Site) => {
                            if (site.loggers?.length === 0 && site.siteName !== 'Unassigned') {

                                if (site.boundary) {
                                    const boundaryInfo = JSON.parse(site.boundary)
                                    if (Array.isArray(boundaryInfo.path)) {
                                        boundariesTemp.push({
                                            site: site.siteId,
                                            path: boundaryInfo.path,
                                            styling: {
                                                strokeWeight: boundaryInfo.styling.strokeWeight,
                                                strokeColor: boundaryInfo.styling.strokeColor,
                                                areaColor: boundaryInfo.styling.areaColor,
                                                transparency: boundaryInfo.styling.transparency
                                            }
                                        })
                                    }
                                }
                                inActiveSiteData.push(site)
                            } else if (site.defaultSite) {

                                if (site.loggers.length > 0) {
                                    site.loggers.forEach((logger:unknown) => {
                                        const loggerData: APISiteLoggerDetail = buildAPILoggerDetail(logger)
                                        loggerData.CompanyName = site.companyName
                                        if (loggerData.Dormant === false) {
                                            unAssignedLoggers.push(loggerData)
                                        }
                                    })
                                }
                               
                                unAssignedLoggers.sort((a, b) => {
                                    // Handle null cases - decide where nulls should go
                                    if (a.DeploymentDate === null && b.DeploymentDate === null) return 0;
                                    if (a.DeploymentDate === null) return 1; // nulls go to end
                                    if (b.DeploymentDate === null) return -1; // nulls go to end

                                    return a.DeploymentDate.localeCompare(b.DeploymentDate);
                                })
                            }
                            else {

                                site.isParent = site.isParent ? 'Yes' : 'No'

                                
                                if (site.boundary) {
                                    const boundaryInfo = JSON.parse(site.boundary)
                                    if (Array.isArray(boundaryInfo.path)) {
                                        boundariesTemp.push({
                                            site: site.siteId,
                                            path: boundaryInfo.path,
                                            styling: {
                                                strokeWeight: boundaryInfo.styling.strokeWeight,
                                                strokeColor: boundaryInfo.styling.strokeColor,
                                                areaColor: boundaryInfo.styling.areaColor,
                                                transparency: boundaryInfo.styling.transparency
                                            }
                                        })
                                    }
                                }
                                const preparedLoggers = []
                                site.loggers.map(logger => {
                                    const loggerData: APISiteLoggerDetail = buildAPILoggerDetail(logger)
                                    let imgSrc = ""
                                    if (loggerData.Model) {
                                        if (loggerData.Model.slice(0, 2) === 'CH') {
                                            imgSrc = CHF
                                            if (loggerData.Model.includes('2P')) {
                                                imgSrc = CHF2P
                                            } else if (loggerData.Model.includes('1P')) {
                                                imgSrc = CHF1P
                                            }
                                        }
                                    }
                                    preparedLoggers.push(loggerData)

                                    markersTemp.push({
                                        position: loggerData.Latitude && loggerData.Longitude ? { lat: loggerData.Latitude, lng: loggerData.Longitude } : { lat: defaultCenter.lat, lng: defaultCenter.lng },
                                        key: loggerData.LoggerId,
                                        serial: loggerData.Serial,
                                        tooltip: {
                                            model: window.location.hostname.includes('zonelog.net') ? GutermannModelConverter(loggerData.Model) : loggerData.Model,
                                            img: window.location.hostname.includes('zonelog.net') ? ZL : imgSrc
                                        },
                                        icon: loggerData.Latitude && loggerData.Longitude ? yellowMarker : redMarker,
                                        siteId: site.siteId
                                    })
                                })
                                site.loggers = preparedLoggers
                                activeSiteData.push(site)
                            }

                            setLoading(false)
                        })

                        setCompanies(companiesTemp)
                        setBoundaries(boundariesTemp)
                        setMarkers(markersTemp)
                        setActiveSites(activeSiteData)
                        setInactiveSites(inActiveSiteData)
                        setLoggersToBeAssigned(unAssignedLoggers)

                    }
                })
                .catch(err => {
                    console.log(err)
                    setAuthorized(false)
                })
        })
        .catch(err => {
            console.log(err)
            setAuthorized(false)
        })
}


export const handleSiteChange = (
    selected:APILoggerDetail[],
    assignDate: Date,
    polygonPath: Coordinates[],
    boundaryStyling: BoundaryStyling,
    hasBoundary: boolean,
    tempName: Name,
    companyId: number,
    editSite: boolean,
    tempSite: Site,
    intl: IntlShape,
    setLoading: (isLoading: boolean) => void,
    setBoundaries: (boundaryData: Boundary[]) => void,
    companies: Company[],
    setCompanies: (companiesData: Company[]) => void,
    setMarkers: (markersData: GPS[]) => void,
    setActiveSites: (activeSites: Site[]) => void,
    setInactiveSites: (inactiveSites: Site[]) => void,
    setLoggersToBeAssigned: (loggers: APILoggerDetail[]) => void,
    setLoggersToBeUnassigned: (loggers: APILoggerDetail[]) => void,
    setAuthorized: (isAuth: boolean) => void,
    loggersToBeUnassigned: APILoggerDetail[],
    setSelectedTab: (tabNumber: number) => void
)
    : void => {
    let boundaryInfo = null
    if (Array.isArray(polygonPath) && polygonPath.length > 0) {
        boundaryInfo = JSON.stringify({ path: polygonPath, styling: boundaryStyling })
    }

    if (tempName.siteNameTemp && tempName.siteRefTemp) {
        if (!editSite) {
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    SiteName: tempName.siteRefTemp,
                    SiteNameUserFriendly: tempName.siteNameTemp,
                    Latitude: tempSite.Latitude || 0,
                    Longitude: tempSite.Longitude || 0,
                    CreatedDate: new Date(),
                    FkCompanyId: companyId,
                    DefaultSite: false,
                    FkEASiteId: null,
                    Boundary: hasBoundary && selected.length !== 0 ? boundaryInfo : null
                })
            };
            CallGetAPI(CreateUrl('/api/aquaguard/Site'), requestOptions)
                .then(data => {
                    createSuccessNotification(intl)

                    if (selected.length > 0) {

                        const loggerIds: Array<{ Id: number }> = [];
                        selected.forEach(logger => loggerIds.push({ Id: logger.LoggerId }))
                        const requestOptions = {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({
                                siteId: data.id,
                                lastUpdate: data.lastUpdate,
                                loggers: loggerIds,
                                assignLogReadingsFromDate: assignDate,
                                deploymentGuid: null
                            })
                        };

                        CallPostAPI(CreateUrl('/api/Aquaguard/AssignLoggersToSite'), requestOptions)
                            .then(() => {
                                createSuccessNotification(intl)
                                setTimeout(() =>
                                    reloadData(
                                        setLoading,
                                        setBoundaries,
                                        companies,
                                        setCompanies,
                                        setMarkers,
                                        setActiveSites,
                                        setInactiveSites,
                                        setLoggersToBeAssigned,
                                        setAuthorized
                                    ), 500
                                )
                            })
                            .catch(err => {
                                createErrorNotification(intl)
                                console.log(err)
                            })
                    }
                    handleUnAssigningLoggersCall(
                        loggersToBeUnassigned,
                        intl,
                        setLoggersToBeUnassigned,
                        setSelectedTab,
                        setLoading,
                        setBoundaries,
                        companies,
                        setCompanies,
                        setMarkers,
                        setActiveSites,
                        setInactiveSites,
                        setLoggersToBeAssigned,
                        setAuthorized
                    )
                    if (selected.length === 0 && loggersToBeUnassigned.length === 0) setTimeout(() => reloadData(
                        setLoading,
                        setBoundaries,
                        companies,
                        setCompanies,
                        setMarkers,
                        setActiveSites,
                        setInactiveSites,
                        setLoggersToBeAssigned,
                        setAuthorized), 500
                    )
                })
                .catch(err => {
                    createErrorNotification(intl)
                    console.log(err)
                })
        } else {
            const requestOptions = {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    Id: tempSite.siteId,
                    SiteName: tempName.siteRefTemp,
                    SiteNameUserFriendly: tempName.siteNameTemp,
                    Created: tempSite.created,
                    Deleted: tempSite.deleted,
                    Latitude: tempSite.latitude || 0,
                    Longitude: tempSite.longitude || 0,
                    FKCompanyId: companyId,
                    DefaultSite: false,
                    LastUpdate: tempSite.lastUpdate,
                    FkEASiteId: null,
                    Boundary: hasBoundary ? boundaryInfo : null
                })
            };

            CallPutAPI(CreateUrl('/api/Aquaguard/Site/' + tempSite.siteId), requestOptions)
                .then(data => {
                    createSuccessNotification(intl)
                    if (selected.length > 0) {

                        const loggerIds: Array<{ Id: number }> = [];
                        selected.forEach(logger => loggerIds.push({ Id: logger.LoggerId }))
                        const requestOptions = {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({
                                siteId: tempSite.siteId,
                                lastUpdate: tempSite.lastUpdate,
                                loggers: loggerIds,
                                assignLogReadingsFromDate: assignDate,
                                deploymentGuid: null
                            })
                        };

                        CallPostAPI(CreateUrl('/api/Aquaguard/AssignLoggersToSite'), requestOptions)
                            .then(() => {
                                createSuccessNotification(intl)
                                setTimeout(() => reloadData(
                                    setLoading,
                                    setBoundaries,
                                    companies,
                                    setCompanies,
                                    setMarkers,
                                    setActiveSites,
                                    setInactiveSites,
                                    setLoggersToBeAssigned,
                                    setAuthorized
                                ), 500)
                            })
                            .catch(err => {
                                createErrorNotification(intl)
                                console.log(err)
                            })
                    }
                    handleUnAssigningLoggersCall(
                        loggersToBeUnassigned,
                        intl,
                        setLoggersToBeUnassigned,
                        setSelectedTab,
                        setLoading,
                        setBoundaries,
                        companies,
                        setCompanies,
                        setMarkers,
                        setActiveSites,
                        setInactiveSites,
                        setLoggersToBeAssigned,
                        setAuthorized
                    )
                    if (selected.length === 0 && loggersToBeUnassigned.length === 0) setTimeout(() => reloadData(
                        setLoading,
                        setBoundaries,
                        companies,
                        setCompanies,
                        setMarkers,
                        setActiveSites,
                        setInactiveSites,
                        setLoggersToBeAssigned,
                        setAuthorized
                    ), 500)
                })
                .catch(err => {
                    createErrorNotification(intl)
                    console.log(err)
                })

        }
    }
    else {
        window.alert(intl.formatMessage({ id: 'Site must have a name and ref' }))
    }

}

const handleUnAssigningLoggersCall = (
    loggersToBeUnassigned: APILoggerDetail[],
    intl: IntlShape,
    setLoggersToBeUnassigned: (loggers: APILoggerDetail[]) => void,
    setSelectedTab: (tabNumber: number) => void,
    setLoading: (isLoading: boolean) => void,
    setBoundaries: (boundaryData: Boundary[]) => void,
    companies: Company[],
    setCompanies: (companiesData: Company[]) => void,
    setMarkers: (markersData: GPS[]) => void,
    setActiveSites: (activeSites: Site[]) => void,
    setInactiveSites: (inactiveSites: Site[]) => void,
    setLoggersToBeAssigned: (loggers: APILoggerDetail[]) => void,
    setAuthorized: (isAuth: boolean) => void
): void => {
    console.log('unassign loggers')
    if (loggersToBeUnassigned.length > 0) {
        const loggerIds: Array<{ Id: number }> = [];
        loggersToBeUnassigned.map((l) => {
            loggerIds.push({ Id: l.loggerId });
        });
        console.log(loggerIds, loggersToBeUnassigned)
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                loggers: loggerIds,
                shutdown: false,
                force: true
            })
        };
        CallPostAPI(CreateUrl('/api/Aquaguard/UndeployLoggers'), requestOptions)
            .then((data) => {
                console.log('suceess removing logger from site', data)
                createSuccessNotification(intl)
                setLoggersToBeUnassigned([])
                setSelectedTab(0)
            })
            .catch(err => {
                createErrorNotification(intl)
                setLoggersToBeUnassigned([])
                console.log(err)
            })
        setTimeout(() => reloadData(
            setLoading,
            setBoundaries,
            companies,
            setCompanies,
            setMarkers,
            setActiveSites,
            setInactiveSites,
            setLoggersToBeAssigned,
            setAuthorized
        ), 500)
    }

} 

export const handleLoggersToBeUnassigned = (
    logger: APISiteLoggerDetail,
    loggersToBeUnassigned: APISiteLoggerDetail[],
    tempSite: Site,
    setTempSite: (siteDetails: Site) => void,
    setLoggersToBeUnassigned: (loggers: APISiteLoggerDetail[]) => void 
):void => {
    const loggersToBeUnassignedTemp = [...loggersToBeUnassigned, logger]
    const siteTemp = tempSite
    if (siteTemp.loggers.length > 1) {
        siteTemp.loggers = siteTemp.loggers.filter(siteLogger => siteLogger.Serial !== logger.Serial)
    } else {
        siteTemp.loggers = []
    }
    console.log(siteTemp, loggersToBeUnassignedTemp)
    setTempSite(siteTemp)
    console.log(loggersToBeUnassignedTemp)
    setLoggersToBeUnassigned(loggersToBeUnassignedTemp)
}

export const handleTextFieldChange = (
    name: string,
    value: string,
    tempName: Name,
    setTempName: (siteChange: Name) => void
): void => {
    console.log(name)
    const siteName = { ...tempName }
    siteName[name] = value
    setTempName(siteName)
}


export const deleteRow = (
    tempSite: Site,
    intl: IntlShape,
    setLoading: (isLoading: boolean) => void,
    setBoundaries: (boundaries: Boundary[]) => void,
    companies: Company[],
    setCompanies: (companiesData: Company[]) => void,
    setMarkers: (markersData: GPS[]) => void,
    setActiveSites: (activeSitesData: Site[]) => void,
    setInactiveSites: (inactiveSitesData: Site[]) => void,
    setLoggersToBeAssigned: (loggerData: APISiteLoggerDetail[]) => void,
    setAuthorized: (isAuth: boolean) => void,
    toggleDeleteModal: () => void
): void => {
    CallDeleteAPI(CreateUrl(`/api/aquaguard/Site?siteId=${tempSite.siteId}&user=${sessionStorage.getItem('userGuid')}`), {})
        .then(async response => {
            if (response.status == 200) {
                createSuccessNotification(intl);
                reloadData(
                    setLoading,
                    setBoundaries,
                    companies,
                    setCompanies,
                    setMarkers,
                    setActiveSites,
                    setInactiveSites,
                    setLoggersToBeAssigned,
                    setAuthorized
                )
            }
        })
        .catch(function (error) {
            createErrorNotification(intl);
            console.log(error);
        });

    toggleDeleteModal()
} 

